const { QuizApp } = require('../../components/quiz-app');

// app.js (which defines global _t) loads with `defer`; this entry does not.
// DOMContentLoaded fires after all deferred scripts, so _t is guaranteed to exist.
document.addEventListener('DOMContentLoaded', function() {
    const quizApp = new QuizApp();
    quizApp.init();
});
